
import { Component, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Data, Event, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ServiceStatus } from '@shared/index';
import dayjs from 'dayjs';
import locale_de from 'dayjs/locale/de';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { LoggedOutModalComponent } from '@shared-angular/components/logged-out-modal/logged-out-modal.component';
import { LanguageService } from '@shared-angular/services/language.service';
import { LoginService } from '@shared-angular/services/login.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, FormsModule],
  providers: [BsModalService]
})
export class AppComponent implements OnDestroy {
  public title = 'ki-toolbox-app';
  //public route: string = "";
  public status: ServiceStatus = "waiting";

  public isFullScreenLayout = false;
  public subscriptions: Subscription[] = [];




  constructor(public router: Router,
    public loginService: LoginService,
    private langService: LanguageService,
    private modalService: BsModalService
  ) {
    // Screenreader benötigen das korrekte lang-Attribut für die geladene Bot-Sprache
    document.documentElement.lang = this.langService.getLanguage();

    if (this.langService.getLanguage() === "de") {
      dayjs.locale(locale_de);
      dayjs.extend(updateLocale);
      dayjs.updateLocale('de', {
        calendar: {
          lastDay: '[Gestern um] HH:mm',
          sameDay: '[Heute um] HH:mm',
          nextDay: '[Morgen um] HH:mm',
          lastWeek: '[Letzten] dddd [um] HH:mm',
          nextWeek: '[Nächsten] dddd [um] HH:mm',
          sameElse: 'DD.MM.YYYY'
        },
        relativeTime: {
          future: "in %s",
          past: "vor %s",
          s: 'ein paar Sekunden',
          m: "einer Minute",
          mm: "%d Minuten",
          h: "einer Stunde",
          hh: "%d Stunden",
          d: "einem Tag",
          dd: "%d Tagen",
          M: "einem Monat",
          MM: "%d Monaten",
          y: "einem Jahr",
          yy: "%d Jahren"
        }
      });
      dayjs.extend(CustomParseFormat);
    }
    dayjs.extend(relativeTime);
    dayjs.extend(duration);

    this.subscriptions.push(router.events.subscribe((e: Event) => {
      if (e instanceof NavigationEnd) {
        const routeData: Data = this.getRouteData(this.router.routerState.root);
        this.isFullScreenLayout = !!routeData['isFullScreenLayout'];
      }
    }));

    this.loginService.socketAdmin.onLogoutOldSession.subscribe(_los => {
      this.modalService.show(LoggedOutModalComponent);
    });
  }

  private getRouteData(route: ActivatedRoute) {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route.snapshot.data;
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach(s => { s.unsubscribe(); });
  }
}
